export const sanitizeSavingsPlan = (savingsPlan, car_lot_id, checkFeeIncluded) => {
    const {
        version,
        year,
        suggested_factory_price,
        carDescription,
        planDescription,
        percentageToFinance,
        extraordinary,
        pureExtraordinaryInstallment,
        additionalAmount,
        extraordinaryRealInstallment,
        installments,
        validityDate,
        planInstallmentsQuantity,
        subscriptionInstallmentValue,
        staggeredInstallments,
        colors,
        bonifications,
        subscriptionDiscount = null,
        additionalDiscount = null
    } = savingsPlan
    const formattedColors = colors.map((color, index) => ({
        name: color.name,
        hexa_code: color.color,
        order: index
    }))
    const formattedBenefits = bonifications.map(bonification => ({ name: bonification }))
    const additionalAmountFormatted = +additionalAmount?.replace(',', '.') / 100 || null
    const savingsPlanBody = {
        SavingsPlan: {
            datamaster_id: version.id,
            year,
            suggested_factory_price: +suggested_factory_price,
            product_description: carDescription,
            car_lot_id,
            plan_description: planDescription,
            financing_percentage: +percentageToFinance / 100,
            extraordinary_percentage: +extraordinary / 100,
            extraordinary_instalment_amount: pureExtraordinaryInstallment,
            aditional_percentage: additionalAmountFormatted,
            aditional_instalment_amount: extraordinaryRealInstallment,
            pea: Boolean(installments),
            pea_instalment: installments,
            valid_to: validityDate,
            published: Boolean(validityDate),
            instalment_quantity: planInstallmentsQuantity,
            subscription_instalment_amount: subscriptionInstallmentValue,
            is_first_instalment_in_subscription: checkFeeIncluded,
            instalments_ranges: staggeredInstallments,
            colors: formattedColors,
            benefits: formattedBenefits,
            bonifications : {
                subscription_quote_discount: subscriptionDiscount ? subscriptionDiscount / 100 : null,
                total_discount: additionalDiscount
            }
        }
    }
    return savingsPlanBody
}
